import { render, staticRenderFns } from "./pdf-by-grade.vue?vue&type=template&id=b9f474ae&scoped=true&"
import script from "./pdf-by-grade.vue?vue&type=script&lang=js&"
export * from "./pdf-by-grade.vue?vue&type=script&lang=js&"
import style0 from "./pdf-by-grade.vue?vue&type=style&index=0&id=b9f474ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f474ae",
  null
  
)

export default component.exports